<div fxLayout="column">
  <label for="dateTime" >Birth Date</label>
  <input type="datetime-local" id="dateTime" [value]="dateTimeValue">
</div>